const PriceHistoryPlaceholder = () => <div style={{ aspectRatio: "2 / 1" }} />;

PriceHistoryPlaceholder.displayName = "Price History";

export default PriceHistoryPlaceholder;
